import React from 'react'
import { IoFileTrayFullOutline } from 'react-icons/io5'

import './index.scss'

const LoginHint = () => {
    return (
        <div className="loginHint">
            <div className="loginHint-arrow"> </div>
            <div className="loginHint-body">
                <div className="loginHint-top">
                    <IoFileTrayFullOutline/>
                    <div className="loginHint-title">
                        Trying to access invoices
                        <br /> but don't have a login?
                    </div>
                </div>
                <p>
                    Please contact your colleague who is the administrator for your supplier Betterspace account and <strong>ask them to first invite you as a manager</strong> on the Betterspace Supplier platform
                    Settings page.
                </p>
                <p>Once invited, <strong>you'll receive an email with a link to signup</strong> and access the invoices.</p>
            </div>
        </div>
    )
}

export default LoginHint
